/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import InputLabel from 'components/generics/InputLabel/InputLabel';
import Input from 'components/generics/Input/Input';
import Button from 'components/generics/Button/Button';

import { addTemplate, editTemplate, getTemplate } from 'services/API/Checklist';

import 'components/generics/Checklist/Checklist.style.scss';

const errorMessage = err => err?.response?.data?.message || err?.message || 'Unexpected error';

/**
 * Création / édition d'un modèle de checklist : nom + questions ordonnées
 * (texte simple, 3 états au remplissage).
 */
const FormChecklistModel = ({ onSubmit, editId, type }) => {
  const [name, setName] = useState('');
  const [questions, setQuestions] = useState(['']);

  useEffect(() => {
    if (type === 'edit' && editId) {
      getTemplate(editId)
        .then(res => {
          setName(res.data.name || '');
          setQuestions((res.data.items || []).map(item => item.label));
        })
        .catch(err => toast.error(errorMessage(err)));
    }
  }, []);

  const updateQuestion = (index, value) =>
    setQuestions(prev => prev.map((question, position) => (position === index ? value : question)));

  const addQuestion = () => setQuestions(prev => [...prev, '']);

  const removeQuestion = index =>
    setQuestions(prev => (prev.length > 1 ? prev.filter((question, position) => position !== index) : prev));

  const moveQuestion = (index, direction) => {
    const target = index + direction;
    if (target < 0 || target >= questions.length) return;
    setQuestions(prev => {
      const next = [...prev];
      [next[index], next[target]] = [next[target], next[index]];
      return next;
    });
  };

  const validateData = () => {
    const items = questions
      .map(question => question.trim())
      .filter(question => question.length > 0)
      .map(label => ({ label }));

    if (!name.trim()) {
      toast.error('A checklist model needs a name');
      return;
    }
    if (items.length === 0) {
      toast.error('A checklist model needs at least one question');
      return;
    }

    const payload = { name: name.trim(), items };
    const request = type === 'edit' ? editTemplate(payload, editId) : addTemplate(payload);

    request
      .then(() => {
        toast.success(type === 'edit' ? 'Checklist model updated' : 'Checklist model created');
        onSubmit();
      })
      .catch(err => toast.error(errorMessage(err)));
  };

  const action = () => (type === 'edit' ? 'Edit' : 'Add a');

  return (
    <div className="modal__content checklist-model">
      <h2>{action()} checklist model</h2>
      <div className="form-part">
        <InputLabel label="Name" name="name">
          <Input name="name" type="text" value={name} onChange={setName} />
        </InputLabel>
      </div>

      <InputLabel label="Questions" name="questions">
        <div className="checklist-model__questions">
          {questions.map((question, index) => (
            <div className="checklist-model__question" key={index}>
              <Input
                name={`question-${index}`}
                type="text"
                value={question}
                onChange={value => updateQuestion(index, value)}
              />
              <button
                type="button"
                className="checklist-model__move"
                title="Move up"
                disabled={index === 0}
                onClick={() => moveQuestion(index, -1)}
              >
                ↑
              </button>
              <button
                type="button"
                className="checklist-model__move"
                title="Move down"
                disabled={index === questions.length - 1}
                onClick={() => moveQuestion(index, 1)}
              >
                ↓
              </button>
              <button
                type="button"
                className="checklist-model__remove"
                title="Remove"
                disabled={questions.length === 1}
                onClick={() => removeQuestion(index)}
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      </InputLabel>

      <div className="checklist-model__actions">
        <Button text="Add a question" defaultStyle="secondary less_padding" onClick={addQuestion} />
      </div>

      <Button text={`${action()} checklist model`} defaultStyle="primary" onClick={validateData} />
    </div>
  );
};

export default FormChecklistModel;
